import React, { useMemo, useState } from 'react';
import ReactDOM from "react-dom";
import { useSelector } from 'react-redux';
import block from 'bem-cn';
import SVGInline from 'react-svg-inline';

import arrow from './img/selector-arrow.svg';

import './Selector.scss';

const b = block('selector');

const Selector = ({ callBack = f => f, options = [], active = null, isDisabled, isFromLocal = false }) => {

  const { locale } = useSelector(state => state.locale);
  const [isOpen, setOpen] = useState(false);

  const optionsList = useMemo(() => options.filter(t => t.value !== active?.value).map(t =>
    <div className={b('option')} onClick={() => callBack(t.value)} key={t.value}>
      {t.text}
    </div>), [active.value, callBack, options])

  return (
    <>
      {isOpen && ReactDOM.createPortal(<div className={b('overlay')} onClick={() => setOpen(!isOpen)}></div>, document.getElementById('root'))}
      <div className={b({ isOpen })} onClick={() => {
        if (isDisabled) {
          return;
        }
        setOpen(!isOpen);
      }}>
        <div className={b('active')}>
          {isFromLocal ? locale[active?.text] : active?.text}
        </div>
        <SVGInline className={b('arrow', { isOpen }).toString()} svg={arrow} />
        {isOpen ? <div className={b('options')}>
          {optionsList}
        </div> : null}
      </div>
    </>
  )
}

export default Selector;